import { css } from 'styled-components';
export default {
    montserrat: {
        regular: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-style: italic;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-style: italic;
      font-weight: 500;
    `,
        semiBold: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 600;
    `,
        semiBoldItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-style: italic;
      font-weight: 600;
    `,
        bold: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-style: italic;
      font-weight: 700;
    `,
        extraBold: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 800;
    `,
        extraBoldItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-style: italic;
      font-weight: 800;
    `,
    },
};
